<template>
    <div class="eip-create-container">
        <div class="create-host">
            <div class="jc-page-header">
                <div class="jc-container">
                    <el-page-header show-back-icon :title="$t('eip.text.applyPublicIp')" @back="jumpToUp()"
                        class="relative">
                        <template slot="content">
                            <div class="jc-list__header--right">
                                <a :href="Config.EIP_BUY_URL" target="_blank" class="fr buy-info">
                                    {{ $t('create.text.buyMustKnow') }}
                                </a>
                            </div>
                        </template>
                    </el-page-header>
                </div>
            </div>
            <div class="jc-page-content">
                <div class="jc-container pr">
                    <div class="buildTab">
                        <ul>
                            <li id="tab1" @click="setTab('tab', 1, 2)" class="hover">
                                {{ $t('create.text.yearlyOrMonthly') }}
                                <div class="jc-badge-discount">{{ $t('create.text.sale') }}</div>
                            </li>
                            <li id="tab2" @click="setTab('tab', 2, 2)">
                                {{ $t('create.text.byConfigurations') }}
                            </li>
                        </ul>
                    </div>
                    <div class="buildCon" id="con-tab-1">
                        <div class="infoBox">
                            <!-- 地域 -->
                            <div class="jc-page-card">
                                <div class="jc-page-card-header">
                                    <h3 class="jc-page-card-title">{{ $t('create.text.region') }}</h3>
                                </div>
                                <el-form class="jc-form cps-create-form" label-width="130px">
                                    <el-form-item :label="$t('create.text.region') | withColon">
                                        <el-radio-group v-model="selectedRegion" @change="regionChange">
                                            <el-radio-button v-for="(regionName, region, index) in regions" :key="index"
                                                :label="region">
                                                {{ regionName }}
                                            </el-radio-button>
                                        </el-radio-group>
                                        <p class="el-form-item-help">{{ $t('eip.help.createRegion') }}</p>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <!-- 带宽 -->
                            <div class="jc-page-card">
                                <div class="jc-page-card-header">
                                    <h3 class="jc-page-card-title">{{ $t('create.text.bandwidth') }}</h3>
                                </div>
                                <el-form class="jc-form cps-create-form" label-width="130px" :model="bandwidthForm"
                                    :rules="bandwidthFormRules" ref="bandwidthForm" onsubmit="return false">
                                    <!--带宽计费方式-->
                                    <el-form-item :label="$t('eip.text.bandwidthCalMode') | withColon">
                                        <el-radio-group v-model="selectedPaymentType">
                                            <el-radio-button v-for="(item, key) in bandwidthPaymentTypes"
                                                :label="item.value">
                                                {{ item.label }}
                                            </el-radio-button>
                                        </el-radio-group>
                                        <el-tooltip style="margin-left:10px" effect="dark" placement="right"
                                            content="Right Top">
                                            <div slot="content" class="my-os-disk-tip">
                                                {{ $t('create.tooltip.cal') }}
                                                <a v-bind:href="Config.Band_Width_BillUrl" target="_blank"
                                                    style="color:#2C68FF">
                                                    {{ $t('create.tooltip.detail') }}&gt;&gt;
                                                </a>
                                            </div>
                                            <a><i class="jc-icon-question"></i></a>
                                        </el-tooltip>
                                        <p slot="hint" class="auto-vpc-tip" v-if="selectedPaymentType === 3">{{
                                            $t('create.text.autoJoinShareBandwidth') }}</p>
                                    </el-form-item>
                                    <!--线路-->
                                    <el-form-item :label="$t('create.text.line') | withColon">
                                        <el-radio-group v-model="selectedLineType">
                                            <el-radio-button v-for="(item, key, index) in lineTypes" :key="index"
                                                :label="key">{{ item }}
                                            </el-radio-button>
                                        </el-radio-group>
                                        <el-tooltip style="margin-left:10px" effect="dark" placement="right"
                                            content="Right Top">
                                            <div slot="content" class="my-os-disk-tip">
                                                {{ $t('create.tooltip.line', [lineTypes[selectedLineType]]) }}
                                            </div>
                                            <a><i class="jc-icon-question"></i></a>
                                        </el-tooltip>
                                    </el-form-item>
                                    <!--带宽上限-->
                                    <extra-bandwidth v-if="selectedPaymentType !== 3" :createOrNot="true"
                                        v-model="selectedMaxBandwidth" :bandwidth="stockNumber">
                                    </extra-bandwidth>
                                    <!--加入共享带宽-->
                                    <select-bandwidth-package v-show="selectedPaymentType === 3" v-model="bandwidthForm"
                                        :region="selectedRegion" :lineType="selectedLineType">
                                    </select-bandwidth-package>
                                </el-form>
                            </div>
                            <!-- 购买量 -->
                            <div class="jc-page-card">
                                <div class="jc-page-card-header">
                                    <h3 class="jc-page-card-title">{{ $t('eip.text.buyNo') }}</h3>
                                </div>
                                <el-form class="jc-form cps-create-form" label-width="130px">
                                    <el-form-item v-if="currentMode === 'tab1'"
                                        :label="$t('create.text.buyTimeSpan') | withColon">
                                        <div class="my-time-length">
                                            <div class="time-slide">
                                                <ul class="time-choose cl">
                                                    <!--0折用户-->
                                                    <el-tooltip effect="dark" placement="top"
                                                        v-if="allDiscountedInfo[index - 1].message !== ''"
                                                        :content="allDiscountedInfo[index - 1].message"
                                                        v-for='index in firstNine'>
                                                        <li @click="selectMonth(index)" :class="getClass(index)"
                                                            class="time-discount">
                                                            <i></i>{{ index }}
                                                        </li>
                                                    </el-tooltip>
                                                    <!--普通用户-->
                                                    <li v-for='index in firstNine' @click="selectMonth(index)"
                                                        :class="getClass(index)"
                                                        v-if="allDiscountedInfo[index - 1].message === ''">
                                                        {{ index }}
                                                    </li>
                                                    <!--0折用户-->
                                                    <el-tooltip effect="dark" placement="top"
                                                        v-if="allDiscountedInfo[index + 8].message !== ''"
                                                        :content="allDiscountedInfo[index + 8].message"
                                                        v-for='index in lastThree'>
                                                        <li @click="selectYear(index)" class="time-discount"
                                                            :class="getClass(12 * index)">
                                                            <i></i>{{ index + $tc('create.text.yearUnit', index) }}
                                                        </li>
                                                    </el-tooltip>
                                                    <!--普通用户-->
                                                    <li v-for='index in lastThree' @click="selectMonth(index)"
                                                        :class="getClass(12 * index)"
                                                        v-if="allDiscountedInfo[index + 8].message === ''">
                                                        {{ index }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </el-form-item>
                                    <!--自动续费-->
                                    <el-form-item v-if="currentMode === 'tab1'"
                                        :label="$t('create.text.autoRenew') | withColon">
                                        <input id="autoRenewCheckbox" type="checkbox" v-model="autoRenew" />
                                        <span>{{ $t('create.text.autoRenewTip') }}</span>
                                        <el-tooltip style="margin-left:10px" effect="dark" placement="right">
                                            <div slot="content" class="my-app-tip">
                                                {{ $t('create.tooltip.autoRenew') }}
                                            </div>
                                            <a><i class="jc-icon-question"></i></a>
                                        </el-tooltip>
                                    </el-form-item>
                                    <el-form-item :label="$t('create.text.count') | withColon">
                                        <!-- <el-input-number v-model="selectedEipNumber" :min="1" label=""
                                            :max="availableQuotaNumber" @input.native="changeSelectedNumber">
                                        </el-input-number> -->
                                        <el-input-number v-model="selectedEipNumber" :min="1" label=""
                                            :max="availableQuotaNumber">
                                        </el-input-number>
                                        <el-tooltip style="margin-left:10px" effect="dark" placement="right">
                                            <div slot="content" class="my-app-tip">{{ $t('eip.help.countLimitedByEid') }}
                                            </div>
                                            <a><i class="jc-icon-question"></i></a>
                                        </el-tooltip>
                                        <p class="el-form-item-help">{{ $t('eip.help.countTooltip') }}</p>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <!-- 标签 -->
                            <div class="jc-page-card">
                                <div class="jc-page-card-header">
                                    <h3 class="jc-page-card-title">{{ $t('listPage.text.tags') }}</h3>
                                </div>
                                <el-form class="jc-page-card cps-create-form" :model="tagForm" label-width="130px"
                                    :rules="tagRules">
                                    <el-form-item class="code-value-tip" :label="$t('listPage.text.tags') | withColon">
                                        <jcb-tag-creationform v-model="tagForm.tags" ref="tagForm"
                                            :regionId="selectedRegion" @error="errorHandler" :strict="tagValidation">
                                        </jcb-tag-creationform>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                    <!-- 已选配置 -->
                    <div id="selected" class="jc-form-create-selected">
                        <h3 class="selected-title">
                            {{ $t('create.text.selectedConfig') }}</h3>
                        <el-form label-width="100px" class="jc-datashow-list">
                            <!--地域-->
                            <el-form-item :label="$t('create.text.region')">
                                <p v-if="regions[selectedRegion]">
                                    {{ regions[selectedRegion] }}</p>
                                <p v-else>--</p>
                            </el-form-item>
                            <!--线路-->
                            <el-form-item :label="$t('eip.text.line')">
                                <p>{{ lineTypes[selectedLineType] }}</p>
                            </el-form-item>
                            <!--带宽-->
                            <el-form-item :label="$t('create.text.bandwidth')" :title="$t('create.text.bandwidth')">
                                <span v-if="selectedPaymentType == 3">{{ this.bandwidthForm.selectBandwidthPackageName ?
                                    $t('eip.help.byPublicBandwidth',
                                        [bandwidthForm.selectBandwidthPackageBandwidth]) : "--" }}</span>
                                <span v-else>{{ $t('eip.help.byBandwidth', [selectedMaxBandwidth]) }}</span>
                            </el-form-item>
                            <!--已加入共享带宽-->
                            <el-form-item :label="$t('create.text.aleadyJoinSharedBandwidth')">
                                <p v-if="bandwidthForm.selectBandwidthPackageName" class="selected-ellipsis"
                                    :title="bandwidthForm.selectBandwidthPackageName + $t('create.help.aleadyJoinSharedBandwidth', [bandwidthForm.selectBandwidthPackageBandwidth])">
                                    {{ bandwidthForm.selectBandwidthPackageName }}{{
                                        $t('create.help.aleadyJoinSharedBandwidth',
                                            [bandwidthForm.selectBandwidthPackageBandwidth]) }}
                                </p>
                                <p v-else>--</p>
                            </el-form-item>
                            <!--购买时长-->
                            <el-form-item v-if="currentMode === 'tab1'" :label="$t('create.text.buySpan')"
                                :title="$t('create.text.buyTimeSpan')">
                                <p v-if="selectedMonth % 12 !== 0">{{ selectedMonth }} {{ $tc('create.text.month',
                                    selectedMonth) }}</p>
                                <p v-else-if="selectedMonth % 12 === 0">{{ selectedMonth / 12 }}
                                    {{ $tc('create.text.yearUnit',
                                        selectedMonth / 12) }}</p>
                                <p v-else>--</p>
                            </el-form-item>
                            <!--购买数量-->
                            <el-form-item :label="$t('create.text.buyNum')">
                                <p>{{ selectedEipNumber }}</p>
                            </el-form-item>
                            <!--费用-->
                            <section class="selected-cost">
                                <h3 class="selected-cost-title">
                                    {{ $t('create.text.cost') }}</h3>
                                <!--包年包月计费-->
                                <div v-if="currentMode === 'tab1'">
                                    <el-form-item :label="$t('detail.text.publicNetIP')">
                                        <p class="form-item-nopadding"
                                            :class="[totalDiscount > 0 ? '' : 'form-item-bottom']">
                                            <span class="price">￥{{ discountedTotalPrice }}</span>
                                            <span class="none">{{ calTotalPrice.discountedTotalPrice }}</span>
                                        </p>
                                    </el-form-item>
                                    <save-price v-if="totalDiscount > 0" :totalDiscount="favorablePricePerHour"
                                        :originPrice="totalPrice"></save-price>
                                </div>
                                <!--按配置计费-->
                                <div v-if="currentMode === 'tab2'">
                                    <el-form-item :label="$t('detail.text.publicNetIP')">
                                        <p class="form-item-nopadding"
                                            :class="[configurationTotalDiscount > 0 ? '' : 'form-item-bottom']">
                                            <span class="price">
                                                {{ $t('create.text.feePerHour',
                                                    [discountByConfigurationsTotalPrice]) }}</span>
                                            <span class="none">{{ calTotalPrice.discountedTotalPrice }}</span>
                                            <span class="none">{{
                                                configurationCalTotalPrice.discountByConfigurationsTotalPrice }}</span>
                                        </p>
                                    </el-form-item>
                                    <p class="month-total-price">
                                        <span>{{ $t('create.text.configureMonthPay',
                                            [discountByConfigurationsOneMonthPrice]) }}</span>
                                        <span class="none">{{
                                            configurationCalTotalPrice.discountByConfigurationsOneMonthPrice }}</span>
                                    </p>
                                    <save-price v-if="configurationTotalDiscount > 0"
                                        :totalDiscount="configurationTotalDiscount"
                                        :originPrice="configurationTotalPrice"></save-price>
                                </div>
                            </section>
                            <el-button type="primary" size="large"
                                :disabled="!isStockEnough || moreThanQuota || !isCertification" class="my-buy-btn"
                                @click="buy()">{{ isBuyTag }}
                            </el-button>
                            <p v-if="currentMode === 'tab2'" class="like-form-help-item">
                                {{ $t('create.text.yearPackage', [discountedTotalPrice]) }}
                            </p>
                            <!--尚未通过实名认证-->
                            <p v-if="!isCertification" class="red mt10">
                                {{ $t('create.help.noCertification') }}
                                <a :href="Config.REALNAME_URL">
                                    {{ $t('create.help.goCertificate') }}</a>
                            </p>
                            <!--已售罄-->
                            <p v-else-if="!isStockEnough" class="red mt10">
                                <span>{{ $t('eip.help.soldOut') }}</span>
                                <a v-bind:href="Config.WORK_URL" target="_blank">{{ $t('eip.help.openTicket') }}</a>
                                <span>{{ $t('eip.help.increaseLimit') }}</span>
                            </p>
                            <!--超过配额-->
                            <p v-else-if="isStockEnough && moreThanQuota" class="red">
                                {{ $t('create.help.exceedQuota') }}{{ $t('create.help.contact') }}
                                <a v-bind:href="Config.WORK_URL" target="_blank">{{ $t('create.tooltip.ticket') }}</a>
                            </p>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import VueCookie from 'vue-cookie';
import ExtraBandwidth from '@/components/common/extraBandwidth/ExtraBandwidth';
import { CreateTypeConstant, NetworkTypeConstant, I18nConstant, ServiceCodeConstant, BillingTypesConstant } from '@/common/Constants';
import { changeTwoDecimal, mulDecimals, subDecimals } from '@/common/tool';
import ifCertification from '@/mixins/ifCertification';
import SelectBandwidthPackage from '@/components/common/selectBandwidthPackage/SelectBandwidthPackage';
import SavePrice from '@/components/common/SavePrice';
import initSelectedPotision from '@/mixins/initSelectedPotision';
import buyTime from '@/mixins/buyTime';

export default {
    components: { ExtraBandwidth, SelectBandwidthPackage, SavePrice },
    mixins: [ifCertification, initSelectedPotision, buyTime],
    data() {
        // 验证加入共享带宽计费模式是否选择共享带宽
        const validateSelectBandwidthPackage = (rule, value, callback) => {
            if (this.selectedPaymentType === 3) {
                if (!value) {
                    callback(new Error(this.$t('create.placeholder.default')));
                } else {
                    callback()
                }
            } else {
                callback()
            }
        };
        return {
            currentMode: 'tab1',
            tagValidation: true,
            // 区域
            selectedRegion: '',
            // 带宽
            bandwidthPaymentTypes: [
                { label: this.$t('create.placeholder.fixedBandwidth'), value: 1 },
            ],
            selectedPaymentType: 1, // 1包年包月固定带宽 2按配置固定带宽 3加入共享带宽
            selectedLineType: 'BGP', // 线路
            tmpMaxBandwidth: 1,
            selectedMaxBandwidth: 1,
            bandwidthFormRules: {
                selectBandwidthPackage: [
                    {
                        validator: validateSelectBandwidthPackage,
                        message: this.$t('privateNetInstance.empty'),
                        trigger: 'change'
                    }
                ]
            },
            bandwidthForm: {
                selectBandwidthPackage: '',
                selectBandwidthPackageName: '',
                selectBandwidthPackageBandwidth: ''
            },
            // 购买数量
            selectedMonth: 1,
            cutMonth: 0,
            selectedEipNumber: 1,
            isBuyTag: this.$t('create.text.buyNow'),
            // 库存
            isStockEnough: true,
            // 包年包月价格
            discountedTotalPrice: 0,
            totalPrice: 0,
            totalDiscount: 0,
            serviceToken: '',
            // 按配置价格
            discountByConfigurationsTotalPrice: 0,
            discountByConfigurationsOneMonthPrice: 0,
            configurationTotalDiscount: 0,
            configurationTotalPrice: 0,
            // 页面参数选择
            regions: {},
            otherMonth: 0,
            lineTypes: {},
            autoRenew: false, //自动续费
            timeUnit: 3,
            chargeUnit: 3, // 月 计费时长单位 1:小时 2:天 3:月 4:年,
            selectedYear: 1, // 选择年份,
            allSold: true,
            tagForm: {
                tags: []
            },
            tagRules: {
            },
            availableQuotaNumber: 0, // 可用配额
            stockNumber: 0, // 库存,
            // 折扣信息
            discountedInfo: [
                { message: '' },
                { message: '' },
                { message: '' }
            ],
            // 0折用户折扣信息
            allDiscountedInfo: [
                { message: '' },
                { message: '' },
                { message: '' },
                { message: '' },
                { message: '' },
                { message: '' },
                { message: '' },
                { message: '' },
                { message: '' },
                { message: '' },
                { message: '' },
                { message: '' },
            ],
            // 前9个月
            firstNine: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            // 后三年
            lastThree: [1, 2, 3],
            ifAllDiscountedUser: false,
            favorablePricePerHour: '', // // 省 = 原价 - 应付
        };
    },
    computed: {
        /**
          * 包年包月计算
          */
        calTotalPrice() {
            return this.calculateTotalPrice();
        },
        /**
        * 按配置计算
        */
        configurationCalTotalPrice() {
            return this.configurationsCalculateTotalPrice();
        },
        moreThanQuota() {
            return this.availableQuotaNumber < this.selectedEipNumber;
        },
        ServiceCodeConstant: () => ServiceCodeConstant
    },
    watch: {
        selectedRegion(newValue) {
            if (newValue) {
                this.getQuota();
                this.getDiscountInfo();
                this.getLineTypes();
                this.getStock();
            }
        },

        // 切换购买数量的时候，要查一下库存，是否满足当前数量
        selectedEipNumber() {
            this.getStock();
        },

        selectedPaymentType() {
            this.bandwidthForm = {
                selectBandwidthPackage: '',
                selectBandwidthPackageName: '',
                selectBandwidthPackageBandwidth: ''
            };
        }
    },
    created() {
        this.getRegion();
        this.getUserIsCertification();
    },
    methods: {
        // 只能输入整数
        changeSelectedNumber(val) {
            clearTimeout(this.inputNumberTimeout);
            this.inputNumberTimeout = setTimeout(() => {
                let v = val.target.value;
                v = v.replace(/[^0-9]/ig, '');
                this.selectedEipNumber = v
            }, 200)
        },
        /**
         * 地域改变时调用
         * 此方法只初始化购买量中的数量
         * 其他随区域改变的内容见watch
         */
        regionChange() {
            this.selectedEipNumber = 1;
        },
        getClass(num) {
            if (VueCookie.get(this.GLOBALCOOKIE) == I18nConstant.CN || VueCookie.get(this.GLOBALCOOKIE)
                == null) {
                if (num === this.selectedMonth) {
                    return 'cur';
                } if (this.selectedMonth > num) {
                    return 'sel';
                }
                return '';
            } if (VueCookie.get(this.GLOBALCOOKIE) == I18nConstant.EN) {
                if (num === this.selectedMonth) {
                    if (this.selectedMonth == 1) {
                        return 'curSingleEn curEn';
                    }
                    return 'curEn';
                } if (this.selectedMonth > num) {
                    return 'sel';
                }
                return '';
            }
        },
        /**
            * 获取用户EIP配额
        */
        getQuota() {
            let params = {
                region: this.selectedRegion,
                serviceCode: ServiceCodeConstant.CPSEIP
            };
            Ajax.get('/api/cps/eipQuota', params).then(res => {
                // this.availableQuotaNumber = res.data.availableQuota;
                const { availableQuota } = res.data || {};
                /**
                * 2025-12-09 @author: wangyongbo v3.2.6 产品要求配额最大值设置为10
                */
                if (availableQuota && availableQuota >= 10) {
                  this.availableQuotaNumber = 10;
                }
                if (availableQuota && availableQuota < 10 && availableQuota >= 0) {
                  this.availableQuotaNumber = availableQuota;
                }
            }).catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            });
        },
        /**
            * 获取用户EIP库存
        */
        getStock() {
            let params = {
                region: this.selectedRegion,
            };
            Ajax.get('/api/bm/stock', params).then(res => {
                this.stockNumber = res.data.result.available
                if (this.stockNumber >= this.selectedEipNumber) {
                    this.isStockEnough = true;
                } else {
                    this.isStockEnough = false;
                }
            }).catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            });
        },
        getRegion() {
            let params = {
                networkType: NetworkTypeConstant.VPC
            }
            Ajax.get('/api/cps/getRegions', params).then((res) => {
                let regions = res.data.regions
                regions.forEach((item) => {
                    const region = item.region;
                    const regionName = item.regionName;
                    this.regions[region] = regionName;
                });
                const passedRegion = this.$route.query.region;
                if (passedRegion) {
                    this.selectedRegion = passedRegion;
                } else {
                    this.selectedRegion = regions[0].region;
                }
            }).catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            });
        },
        getLineTypes() {
            const param = {
                region: this.selectedRegion
            };
            Ajax.get('/api/cps/getLineTypes', param)
                .then((res) => {
                    const data = res.data.lineTypes;
                    const lineTypes = {};
                    for (let i = 0; i < data.length; i++) {
                        lineTypes[data[i].lineType] = data[i].lineTypeName;
                        this.lineTypes = lineTypes;
                    }
                    this.selectedLineType = Object.keys(this.lineTypes)[0];
                }).catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                });
        },
        // 包年包月计算价格
        calculateTotalPrice() {
            if (!this.selectedRegion) {
                return '';
            }
            this.discountedTotalPrice = this.$t('create.text.calculating');
            this.totalPrice = this.$t('create.text.calculating');
            this.totalDiscount = this.$t('create.text.calculating');
            const param = {
                cmd: 1, // 操作类型 1、创建；2、续费；3、升降配；4、删除
                region: this.selectedRegion,
                timeUnit: this.timeUnit, // 月
                timeSpan: this.timeUnit === 3 ? this.selectedMonth : this.selectedYear,
                bw: this.selectedPaymentType !== 3 ? this.selectedMaxBandwidth : 0,
                count: this.selectedEipNumber,
                createType: CreateTypeConstant.EIP
            };
            // 如果非整数，不计算价格
            if (!/^\d+$/.test(this.selectedEipNumber)) {
                return false;
            }
            Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
                const { discountedTotalPrice, totalPrice, totalDiscount, serviceToken } = res?.data || {};
                this.discountedTotalPrice = changeTwoDecimal(discountedTotalPrice);
                this.totalPrice = changeTwoDecimal(totalPrice);
                this.totalDiscount = changeTwoDecimal(totalDiscount);
                this.favorablePricePerHour = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : null;
                this.serviceToken = serviceToken;
            })
            return '';
        },
        // 按配置计算价格
        configurationsCalculateTotalPrice() {
            if (!this.selectedRegion) {
                return '';
            }
            this.discountByConfigurationsTotalPrice = this.$t('create.text.calculating');
            this.discountByConfigurationsOneMonthPrice = this.$t('create.text.calculating');
            const param = {
                cmd: 1, // 操作类型 1、创建；2、续费；3、升降配；4、删除
                region: this.selectedRegion,
                bw: this.selectedPaymentType !== 3 ? this.selectedMaxBandwidth : 0,
                count: this.selectedEipNumber,
                createType: CreateTypeConstant.EIP,
                billingType: BillingTypesConstant.POSTPAID_BY_DURATION
            };
            // 如果非整数，不计算价格
            if (!/^\d+$/.test(this.selectedEipNumber)) {
                return false;
            }
            Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
                const { discountedTotalPrice, totalPrice, totalDiscount, serviceToken } = res?.data || {};
                this.discountByConfigurationsTotalPrice = changeTwoDecimal(discountedTotalPrice);
                this.discountByConfigurationsOneMonthPrice = changeTwoDecimal(mulDecimals(mulDecimals(discountedTotalPrice, 24), 30));
                this.configurationTotalPrice = changeTwoDecimal(totalPrice);
                this.configurationTotalDiscount = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : null;
                this.serviceToken = serviceToken;
            })
            return '';
        },

        calSelectedMaxBandwidth() {
            this.selectedMaxBandwidth = this.tmpMaxBandwidth;
        },
        selectMonth(selMonth) {
            this.chargeUnit = 3;
            this.timeUnit = 3;
            this.selectedMonth = selMonth;
            this.otherMonth = selMonth;
            switch (selMonth) {
                case 12:
                    this.cutMonth = 2;
                    break;
                case 24:
                    this.cutMonth = 4;
                    break;
                case 36:
                    this.cutMonth = 6;
                    break;
                default:
                    this.cutMonth = 0;
            }
        },
        selectYear(selYear) {
            switch (selYear) {
                case 1:
                    this.selectedMonth = 12;
                    break;
                case 2:
                    this.selectedMonth = 24;
                    break;
                case 3:
                    this.selectedMonth = 36;
                    break;
                default:
                    this.cutMonth = 0;
            }
            this.selectedYear = selYear;
            this.chargeUnit = 4;
            this.timeUnit = 4;
        },

        jumpToUp() {
            this.$router.push({
                name: 'EipList',
                params: { region: this.selectedRegion }
            });
        },
        buy() {
            this.createTempOrder();
        },
        // 创建临时订单
        createTempOrder() {
            const param = {
                orderType: 1, // 订单类型 1、新购；2、续费；3、配置变更
                region: this.selectedRegion, // 区域
                lineType: this.selectedLineType, // 线路
                bw: this.selectedPaymentType !== 3 ? this.selectedMaxBandwidth : 0, // 带宽
                chargeMode: this.currentMode === 'tab1' ? 3 : 1, // 计费类型 1、配置；2、用量；3、包年包月；4、一次性付费
                chargeDuration: this.chargeUnit === 3 ? this.selectedMonth : this.selectedYear, // 计费时长
                chargeUnit: this.chargeUnit, // 计费时长单位 1:小时 2:天 3:月 4:年
                quantity: this.selectedEipNumber, // 购买数量
                clientToken: Normal.getClientToken(), // 用于保证请求的幂等性，唯一
                timestamps: Normal.getClientToken(), // 毫秒时间戳
                createType: CreateTypeConstant.EIP,// 创建类型 basic、vpc、eip
                autoRenew: this.autoRenew, //自动续费
                resourceTags: this.tagForm.tags,
                bandwidthPackageId: this.bandwidthForm.selectBandwidthPackage,
                serviceToken: this.serviceToken
            };
            Ajax.post('/api/cps/eips/addEIPToCar', param, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then((res) => {
                    const orderId = res.data.tempOrderNumber;
                    if (orderId) {
                        window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
                    }
                })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                });
        },
        setTab(name, cursel, n) {
            this.initBandwidthPaymentTypes(cursel);
            for (let i = 1; i <= n; i++) {
                const menu = document.getElementById(name + i);
                const con = document.getElementById(`con-${name}-${i}`);
                menu.className = i === cursel ? 'hover' : '';
            }
            this.currentMode = name + cursel;
        },

        initBandwidthPaymentTypes(type) {
            if (type === 2) {
                this.bandwidthPaymentTypes = [
                    { label: this.$t('create.placeholder.fixedBandwidth'), value: 2 },
                    { label: this.$t('eip.text.joinShareBandwidth'), value: 3 },
                ];
                this.selectedPaymentType = 2;
            } else {
                this.bandwidthPaymentTypes = [
                    { label: this.$t('create.placeholder.fixedBandwidth'), value: 1 },
                ];
                this.selectedPaymentType = 1;
            }
        },
        // 添加标签错误处理
        errorHandler(err) {
            console.log(err)
        },
        // 获取折扣信息
        getDiscountInfo() {
            const param = {
                serviceCode: ServiceCodeConstant.CPSEIP,
                billType: 2, // 包年包月
                billPeriod: '1,2,3',
                timeUnit: 4, // 年
                region: this.selectedRegion,
                buyType: 1, // 1、新购2、续费3、配置变更
                createType: CreateTypeConstant.EIP
            };
            Ajax.get({
                url: '/api/discount',
                action: '/describeLowestDiscount',
                param,
                success: (data) => {
                    if (data.length > 0) {
                        for (let i = 0; i < data.length; i++) {
                            this.ifAllDiscountedUser = true;
                            this.allDiscountedInfo[i].message = data[i].discounts[0].message;
                        }
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss">
@import '../../../assets/scss/createCommon';
@import '../../../assets/scss/selectedConfigure';
@import '../../../assets/scss/sliderCommon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/eip/create/Create.vue